<template>
    <div class="main-reco">
        <span>User & Organizational Recommendations</span>
        <div class="users-div">
            For users who may have been affected, we strongly recommend:
            <br />
            <br />
            <div class="desc-div">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Resetting passwords immediately</span>—especially if reused on other platforms
                </div>
            </div>
            <div class="desc-div">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Enabling multi-factor authentication (MFA)</span> to reduce credential abuse risk
                </div>
            </div>
            <div class="desc-div">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Monitoring for phishing attempts</span> as attackers may attempt social engineering
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.main-reco {
  @apply flex flex-col items-start gap-2;
  
  span {
    @apply text-zinc-700 font-inter text-base font-semibold leading-6;
  }
}

.users-div {
  @apply text-zinc-950 font-inter text-sm font-normal leading-6;
  
  span {
    @apply text-zinc-950 font-inter text-sm font-semibold leading-6;
  }

  .desc-div {
    @apply flex flex-row items-center ml-2;
  }
}
</style>
